// src/context/ToastContext.js
// Toast global — cualquier componente puede llamar showToast(msg, type)
// type: 'success' | 'error' | 'warning' | 'info'

import React, { createContext, useContext, useState, useCallback } from 'react';

const ToastContext = createContext(null);

const BG = {
  success: 'bg-success text-white',
  error:   'bg-danger  text-white',
  warning: 'bg-warning text-dark',
  info:    'bg-info    text-dark',
};

export function ToastProvider({ children }) {
  const [toast, setToast] = useState(null); // { msg, type }
  const timerRef = React.useRef(null);

  const showToast = useCallback((msg, type = 'success') => {
    if (timerRef.current) clearTimeout(timerRef.current);
    setToast({ msg, type });
    timerRef.current = setTimeout(() => setToast(null), 3500);
  }, []);

  return (
    <ToastContext.Provider value={{ showToast }}>
      {children}

      {toast && (
        <div
          className={`toast show position-fixed bottom-0 end-0 m-3 ${BG[toast.type] || BG.info}`}
          style={{ zIndex: 9999, minWidth: '260px' }}
          role="alert"
          aria-live="assertive"
        >
          <div className="d-flex align-items-center">
            <div className="toast-body flex-grow-1">{toast.msg}</div>
            <button
              type="button"
              className="btn-close btn-close-white me-2"
              onClick={() => setToast(null)}
              aria-label="Cerrar"
            />
          </div>
        </div>
      )}
    </ToastContext.Provider>
  );
}

export function useToast() {
  const ctx = useContext(ToastContext);
  if (!ctx) throw new Error('useToast must be used inside <ToastProvider>');
  return ctx;
}
